// Centralized image set — all user-provided defense imagery, mapped to the right section.
export const IMAGES = {
  // 01 — Hero banner (armored vehicle + drone + command-center overlay)
  hero: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/plnchoqf_01_hero_banner.png',

  // 06 — Researchers in lab with drone — used for Who We Are
  whoWeAreLab: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/7mhwsetb_06_research_innovation.png',
  // Newly generated Nano Banana image for Research for Next-Generation Defense Technologies
  researchCollab: '/generated/research_next_gen.png',

  // 02 — Armored vehicle indoors + armor material samples → Ballistic Protection
  ballisticVehicle: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/8wqel9zx_02_ballistic_protection.png',

  // 09 — Maintenance facility with armored truck + technical fluids → Ground Vehicle Mobility
  mobilityMaintenance: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/bn1gie41_09_operational_suport.png',

  // 03 — CBRNE specialist with detector → CBRNE Defense
  cbrneSpecialist: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/l5gnyfbx_03_cbrne_protection.png',

  // 04 — Ammunition engineering lab → Ammunition & Weapon Systems
  ammoLab: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/mtbq7xyq_04_ammunition_engineering.png',

  // 05 — Anti-drone command center → Counter-UAS
  cuasCommand: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/yytpvt6p_05_counter_uas.png',

  // Battery testing laboratory with cycling equipment → Battery Technology
  batteryLab: 'https://images.unsplash.com/photo-1578496479914-7ef3b0193be3?crop=entropy&cs=srgb&fm=jpg&q=85',

  // Newly generated Nano Banana image for Strategic Partnerships
  partnershipsMeeting: '/generated/strategic_partnerships.png',

  // 08 — CDPA Systems Concept HQ building → Contact section background
  contactBuilding: 'https://customer-assets.emergentagent.com/job_cdpa-defense-tech/artifacts/bl1tsfoy_08_contact_headquarters.png',
};
